import { render, staticRenderFns } from "./form-portfolio.vue?vue&type=template&id=03026b74&lang=pug&"
import script from "./form-portfolio.vue?vue&type=script&lang=js&"
export * from "./form-portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports